import PubSub    from 'pubsub-js';
import Console   from './common/Console.js';
import PageEvent from './common/PageEvent.js';
import Util      from './common/Util.js';
import Loading   from './common/Loading.js';
import Accessibility   from './module/Accessibility.js';

export default class Navigation extends PageEvent {

	constructor() {

		super();

		this.DOM = {};

		this.DOM.body = document.body;

		this.DOM.header = document.querySelector('.header');

		this.lastScroll = 0;

	}

	/*
	** setActive
	*/

	static setActive (controller, id_page, id_category) {

		Console.log('Navigation::setActive('+ controller +','+ id_page +','+ id_category +')');

		this.selectSection(controller);

		this.selectPage(id_page);

		this.selectCategory(id_category);

	}

	static selectSection (controller) {

		// sections
		const sectionsEl = document.querySelectorAll('.sections__item');

		for (let i = 0; i < sectionsEl.length; ++i)
		{
			sectionsEl[i].classList.remove('selected');

			sectionsEl[i].querySelector('.sections__anchor').classList.remove('selected');
		}

		// section
		const sectionEl = document.querySelector('.sections__item[data-controller="'+ controller +'"]');

		if (sectionEl !== null)
		{
			sectionEl.classList.add('selected');

			sectionEl.querySelector('.sections__anchor').classList.add('selected');
		}

	}

	static selectPage (id_page) {

		// pages
		const pagesEl = document.querySelectorAll('.pages__anchor');

		for (let i = 0; i < pagesEl.length; ++i)
		{
			pagesEl[i].classList.remove('selected');
		}

		// page
		const pagesSelectedEl = document.querySelectorAll('.pages__anchor[data-id="'+ id_page +'"]');

		for (let i = 0; i < pagesSelectedEl.length; ++i)
		{
			pagesSelectedEl[i].classList.add('selected');
		}

	}

	static selectCategory (id_category) {

		// categories
		const categoriesEl = document.querySelectorAll('.categories__anchor');

		for (let i = 0; i < categoriesEl.length; ++i)
		{
			categoriesEl[i].classList.remove('selected');
		}

		// category
		const categoriesSelectedEl = document.querySelectorAll('.categories__anchor[data-id="'+ id_category +'"]');

		for (let i = 0; i < categoriesSelectedEl.length; ++i)
		{
			categoriesSelectedEl[i].classList.add('selected');
		}

	}

	/*
	** init
	*/

	init() {

		// burger
		this.burger();

		// menu
		this.menu();

		// accessibility
		this.accessibility = new Accessibility();
		this.accessibility.load();

	}

	/*
	** burger
	*/

	burger() {

		// burger
		const burger = this.DOM.header.querySelector('.header__burger');

		burger.addEventListener('click', event =>
		{
			event.preventDefault();
			event.stopPropagation();

			if ( document.body.classList.contains('body--header-opened') )
			{
				this.close();
			}
			 else
			{
				this.open();
			}

		}, false);

	}

	open() {

		this.DOM.body.classList.add('body--header-opened');

	}

	close() {

		this.DOM.body.classList.remove('body--header-opened');

	}

	/*
	** menu
	*/

	menu() {

		const selected = document.querySelector('.sections__anchor.selected');

		if (selected)
		{
			const parent = selected.closest('.sections__item');

			if (parent)
			{
				parent.classList.add('active');
			}
		}

		document.querySelectorAll('.js-section-toggle').forEach(item =>
		{
			item.addEventListener('click', function(e) {

				e.preventDefault();
				e.stopPropagation();

				const parent = this.closest('.sections__item');

				document.querySelectorAll('.sections__item').forEach(el =>
				{
					if (el !== parent)
					{
						el.classList.remove('active');
					}
				});

				parent.classList.toggle('active');
			});
		});

		document.querySelectorAll('.js-section-link, .pages__anchor').forEach(item =>
		{
			item.addEventListener('click', function()
			{
				document.querySelectorAll('.sections__item').forEach(el =>
				{
					el.classList.remove('active');
				});
			});
		});

		document.addEventListener('click', function(e)
		{
			if (!e.target.closest('.sections'))
			{
				document.querySelectorAll('.sections__item').forEach(el =>
				{
					el.classList.remove('active');
				});
			}
		});

	}

	/*
	** resize
	*/

	resize (event) {

		//

	}

	/*
	** scroll
	*/

	scroll (event) {

		super.scroll(event);

		// scrolled
		this.isScrolled();

		// scrollDown
		// this.isScrollDown();

	}

	isScrolled() {

		const scrollTop = Util.getScrollTop();

		if ( scrollTop > 5 )
		{
			this.DOM.body.classList.add('body--scrolled');
		}
		 else
		{
			this.DOM.body.classList.remove('body--scrolled');
		}

		if ( scrollTop > (Util.windowHeight()) )
		{
			this.DOM.body.classList.add('body--xscrolled');
		}
		else
		{
			this.DOM.body.classList.remove('body--xscrolled');
		}

	}

	isScrollDown() {

		const currentScroll = window.pageYOffset;

		if (currentScroll > this.lastScroll)
		{
			if ( !this.DOM.body.classList.contains('scroll-down') )
			{
				this.DOM.body.classList.add('scroll-down');
			}
		}
		 else if (currentScroll < this.lastScroll)
		{
			if ( this.DOM.body.classList.contains('scroll-down') )
			{
				this.DOM.body.classList.remove('scroll-down');
			}
		}

		this.lastScroll = currentScroll;

	}

	/*
	** start
	*/

	start() {

		Console.log('Navigation::start');

		// load
		this.load();

		// init
		this.init();

		// resize
		this.resize();

	}

}